'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceNoKeysHistoryNav;
/**
 * Previene la navigazione della pagina premendo il tasto BACKSPACE (keyCode 8)
 * @see http://stackoverflow.com/questions/1495219/how-can-i-prevent-the-backspace-key-from-navigating-back?lq=1
 */
function iceNoKeysHistoryNav(_) {
  return {
    restrict: 'A',
    link: linkFn
  };

  function linkFn() {
    //alert('iceNoKeysHistoryNav linking');
    $(document).unbind('keydown').bind('keydown', preventFn);

    var blockingInputElementTypes = ['TEXT', 'PASSWORD', 'FILE', 'SEARCH', 'EMAIL', 'NUMBER', 'DATE'];
    var isBlockingInputType = _.memoize(function isBlockingInputType(type) {
      return _.find(blockingInputElementTypes, function (blockType) {
        return blockType == type;
      });
    });

    function preventFn(event) {
      var doPrevent = false;
      if (event.keyCode === 8) {
        var d = event.srcElement || event.target;

        if (d.tagName.toUpperCase() === 'INPUT' && isBlockingInputType(d.type.toUpperCase()) || d.tagName.toUpperCase() === 'TEXTAREA') {
          doPrevent = d.readOnly || d.disabled;
        } else {
          doPrevent = true;
        }
      }

      if (doPrevent) {
        console.log('iceNoKeysHistoryNav: prevented key event', event.keyCode);
        event.preventDefault();
      }
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.ui/ice-no-keys-history-nav.directive.js
// module id = 143
// module chunks = 2